import React, { useContext } from 'react';
import Skeleton from 'react-loading-skeleton';
import { TeApiContext } from '@ecommerce/nest-ssr/common';

import './multi-carousel-placeholder-item.scss';

const MultiCarouselPlaceholderItem: React.FC = () => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div className={`carousel-placeholder__item${api.getDevice() === 'mobile' ? ' mobile' : ''}`}>
            <div className="carousel-placeholder__item__img">
                <Skeleton height={162} width={162} />
            </div>
            <div className="carousel-placeholder__item__title">
                <Skeleton />
                <Skeleton />
            </div>
            <div className="carousel-placeholder__item__stars">
                <Skeleton width={120} />
            </div>
            <div className="carousel-placeholder__item__price">
                <Skeleton width={100} />
            </div>
            <div className="carousel-placeholder__item__number">
                <Skeleton width={120} />
            </div>
        </div>
    );
};

export default MultiCarouselPlaceholderItem;
